import { Button } from "./Button";
import styles from "./smallStepperButton.module.scss";
import classnames from "classnames/bind";

const classNameBuilder = classnames.bind(styles);

export const SmallStepperButton = ({
  className,
  children,
  tooltip,
  ...rest
}) => (
  <Button className={classNameBuilder("update-button", className)} {...rest}>
    {tooltip}
    <div className={styles["icon"]}>{children}</div>
  </Button>
);
